module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.448c34a56d699c29117a.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/assets/fonts/bootstrap/glyphicons-halflings-regular.woff2?v=4.4.0
// module id = 8K94
// module chunks = 1